(function () {
  // Accordion: open / close one answer
  function faqToggle(item) {
    var answer = item.querySelector('.faq-answer');
    var icon   = item.querySelector('.faq-icon');
    var label  = item.querySelector('.faq-question span');
    var open   = item.classList.toggle('is-open');
    if (open) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      answer.classList.remove('opacity-0');
      answer.classList.add('opacity-100');
      if (icon)  { icon.style.transform = 'rotate(180deg)'; icon.classList.remove('text-gray-300'); icon.classList.add('text-brand'); }
      if (label) { label.classList.remove('text-black'); label.classList.add('text-brand'); }
    } else {
      answer.style.maxHeight = '0px';
      answer.classList.add('opacity-0');
      answer.classList.remove('opacity-100');
      if (icon)  { icon.style.transform = ''; icon.classList.add('text-gray-300'); icon.classList.remove('text-brand'); }
      if (label) { label.classList.add('text-black'); label.classList.remove('text-brand'); }
    }
  }

  document.querySelectorAll('.faq-item .faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () { faqToggle(btn.closest('.faq-item')); });
  });

  // Tabs: filter items client-side by section
  var tabs  = document.querySelectorAll('.faq-tab');
  var items = document.querySelectorAll('.faq-item');
  var empty = document.querySelector('.faq-empty');

  function sectionsOf(item) {
    try { return JSON.parse(item.getAttribute('data-sections') || '[]').map(Number); }
    catch (e) { return []; }
  }

  function activate(tab) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.classList.toggle('bg-brand', on);
      t.classList.toggle('text-brand-text', on);
      t.classList.toggle('shadow-lg', on);
      t.classList.toggle('bg-white', !on);
      t.classList.toggle('lg:bg-transparent', !on);
      t.classList.toggle('text-gray-500', !on);
      t.classList.toggle('hover:bg-gray-50', !on);
    });

    var sel = tab.getAttribute('data-faq-tab');
    var visible = 0;
    items.forEach(function (item) {
      var show = sel === 'all' || sectionsOf(item).indexOf(Number(sel)) !== -1;
      item.style.display = show ? '' : 'none';
      if (show) visible++;
      // collapse hidden ones for a clean state
      if (!show && item.classList.contains('is-open')) faqToggleClose(item);
    });
    if (empty) empty.style.display = visible ? 'none' : 'block';
  }

  function faqToggleClose(item) {
    item.classList.remove('is-open');
    var answer = item.querySelector('.faq-answer');
    var icon   = item.querySelector('.faq-icon');
    var label  = item.querySelector('.faq-question span');
    answer.style.maxHeight = '0px';
    answer.classList.add('opacity-0'); answer.classList.remove('opacity-100');
    if (icon)  { icon.style.transform = ''; icon.classList.add('text-gray-300'); icon.classList.remove('text-brand'); }
    if (label) { label.classList.add('text-black'); label.classList.remove('text-brand'); }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { activate(tab); });
  });
})();
